import { render } from "./ProjectList.vue?vue&type=template&id=0f504a28&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=0f504a28&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f504a28"],['__file',"src/views/h5/crm/project/manage/ProjectList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f504a28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f504a28', __exports__)) {
    api.reload('0f504a28', __exports__)
  }
  
  module.hot.accept("./ProjectList.vue?vue&type=template&id=0f504a28&scoped=true", () => {
    api.rerender('0f504a28', render)
  })

}


export default __exports__